<template>
  <div id="app">
    <TextCalculator />
  </div>
</template>

<script>
import TextCalculator from "./components/TextCalculator.vue";

export default {
  name: "App",
  components: {
    TextCalculator,
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 8px;
  background-color: rgba(6, 7, 13, 0.85);
}
#app {
  color: rgba(155, 155, 155, 0.85);
  font: normal 16px/1.4 "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
